import React, { useEffect, useState } from 'react';
import SubDataModelTable from './RecommendedTermsTable';
import useStyles from './styles';

const RecommendedTermsOverviewViewer = (props) => {
    const classes = useStyles()

    const { orgId, appId, members, currentOpportunityId, formData, selectedStep, block, loader, blockState } = props
    const { document } = props.formData
    const { chartUniqueId } = props.data

    const [tableHeaders, setTableHeaders] = useState([])
    const [currentDataModel, setCurrentDataModel] = useState({})

    useEffect(() => {
        if (formData?.dataModel[block?.dataModel]) {
            const dataElements = formData.dataModel[block.dataModel].dataElements || []
            let tHeaders = []
            if (block.list?.dataElements?.length) {
                tHeaders = getHeaders(dataElements, block.list.dataElements)
            }
            setTableHeaders(tHeaders)
            setCurrentDataModel(formData.dataModel[block.dataModel])
        }
    }, [formData?.dataModel[block?.dataModel]])

    const getHeaders = (dataElements, selectedElements) => {
        let fdes = []
        if (selectedElements?.length) {
            fdes = JSON.parse(JSON.stringify(selectedElements))
        }
        if (dataElements?.length) {
            fdes = fdes.map(fde => {
                let sde = dataElements.find(de => de.name === fde.value)
                if (sde?.name) {
                    return {
                        ...sde,
                        ...fde
                    }
                } else {
                    return fde
                }
            })
        }
        return fdes
    }

    const onTableActionClick = (type, data, event) => {
        console.log('onTableActionClick')
    }

    return (
        <SubDataModelTable
            classes={classes}
            enableActions={block.actions?.enable}
            tableActions={block.actions}
            tableHeaders={tableHeaders}
            tableRows={blockState[block.name]}
            onTableActionClick={onTableActionClick}
            stripedTable={block.list?.stripedTable}
            tableStyle={block.list?.tableStyle || {}}
            stickyHeader={block.list?.stickyHeader}
            headerStyle={block.list?.headerStyle || {}}

            formData={formData}
            loader={loader}
            chartUniqueId={chartUniqueId}
            selectedStep={selectedStep}
            block={block}
            isLoading={formData[`${chartUniqueId}_${selectedStep.name}_${block.name}_loading`]}
        />
    )
}

export default RecommendedTermsOverviewViewer